function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.define-property.js";

/*
 *  Header Navigation
 *    Scripts for the header navigation
 *
 *  Version:
 *    1.0.0 - 2020/10/19
 */
import { initCarousel } from "../../objects/carousel";
import { responsiveMediaAbove, responsiveMediaBelow, responsiveQuery } from './../../settings/responsive';
import { CLASS_ACTIVE, CLASS_VISIBLE } from '../../tools/constants/classes'; // Selectors

var SELECTOR_QUOTES_CONTAINER = '[data-mobile-quotes-container]';
var SELECTOR_MOBILE_CAROUSEL = '[data-mobile-quotes-carousel]';
var SELECTOR_CAROUSEL_WRAP = '[data-mobile-quotes-carousel-wrap]';
var SELECTOR_CAROUSEL_PROGRESS = '[data-carousel-progress]';
var SELECTOR_PUBLICATIONS = '[data-publication]';
var SELECTOR_QUOTES = '[data-quote]'; // Attributes

var ATTR_QUOTE_INDEX = 'data-quote-index';
/*
  Events
*/
// Menu overlay hover events

document.querySelectorAll(SELECTOR_QUOTES_CONTAINER).forEach(function (element) {
  var carousel = document.querySelector(SELECTOR_MOBILE_CAROUSEL);
  if (!carousel) return;
  var progressBar = element.querySelector(SELECTOR_CAROUSEL_PROGRESS);
  var carouselWrap = element.querySelector(SELECTOR_CAROUSEL_WRAP);
  var publications = element.querySelectorAll(SELECTOR_PUBLICATIONS);
  var quotes = element.querySelectorAll(SELECTOR_QUOTES); // Desktop click to change quote

  publications.forEach(function (pub) {
    pub.addEventListener('click', function () {
      var pubIndex = pub.getAttribute(ATTR_QUOTE_INDEX);
      publications.forEach(function (p) {
        return p.classList.remove(CLASS_VISIBLE);
      });
      pub.classList.add(CLASS_VISIBLE);
      quotes.forEach(function (quote) {
        var quoteIndex = quote.getAttribute(ATTR_QUOTE_INDEX);
        quote.classList.remove(CLASS_VISIBLE);

        if (quoteIndex === pubIndex) {
          quote.classList.add(CLASS_VISIBLE);
        }
      });
    });
  });
  if (!progressBar || !carouselWrap) return;
  var keenCarousel = initCarousel(carouselWrap, {
    slidesPerView: 1,
    loop: true,
    dragSpeed: 2,
    breakpoints: _defineProperty({}, responsiveQuery('MEDIUM'), {
      created: function created(slider) {
        return slider.destroy();
      }
    })
  }, undefined, undefined, undefined, undefined, progressBar);

  var onResize = function onResize() {
    if (!carousel) return;
    var slider = keenCarousel.slider;

    if (responsiveMediaAbove('MEDIUM')) {
      slider.destroy();
    } else if (responsiveMediaBelow('MEDIUM')) {
      slider.refresh();
    }
  };

  window.addEventListener('resize', onResize);
});